import { useState, useEffect } from 'react';
import { Warning } from '@phosphor-icons/react';
import { subscribeToRateLimit } from '../../services/api';

/**
 * RateLimitBanner - Shows when API rate limits are hit
 * Displays countdown until rate limit resets
 */
export default function RateLimitBanner() {
  const [rateLimitState, setRateLimitState] = useState({ isLimited: false });
  const [countdown, setCountdown] = useState(0);

  // Subscribe to rate limit state changes
  useEffect(() => {
    const unsubscribe = subscribeToRateLimit(setRateLimitState);
    return unsubscribe;
  }, []);

  // Countdown timer
  useEffect(() => {
    if (!rateLimitState.isLimited || !rateLimitState.resetTime) {
      setCountdown(0);
      return;
    }

    function updateCountdown() {
      const remaining = Math.max(0, Math.ceil((rateLimitState.resetTime - Date.now()) / 1000));
      setCountdown(remaining);
    }

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);

    return () => clearInterval(interval);
  }, [rateLimitState.isLimited, rateLimitState.resetTime]);

  if (!rateLimitState.isLimited) return null;

  return (
    <div 
      className="px-4 py-2 text-sm text-center"
      style={{ 
        backgroundColor: 'rgba(217, 119, 6, 0.15)',
        borderBottom: '1px solid rgba(217, 119, 6, 0.3)',
        color: '#B45309',
      }}
      role="alert"
      aria-live="polite"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-2">
        <Warning size={16} weight="fill" aria-hidden="true" />
        <span>
          <strong>Rate limit reached.</strong>
          {' '}Please wait {countdown > 0 ? `${countdown}s` : 'a moment'} before making more requests.
        </span>
      </div>
    </div>
  );
}
